// src/app/role.guard.ts
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthRole, UserRole } from './services/verifyRole.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  constructor(
    private authRole: AuthRole,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    // admin bypass
    if (this.authRole.getUserRole() === 'Admin') {
      return true;
    }
    // referral users only allowed to /mi-cuenta
    if (this.authRole.getIsReferral() && !state.url.startsWith('/mi-cuenta')) {
      return this.router.parseUrl('/mi-cuenta');
    }
    // role-based routes
    const allowed = route.data['roles'] as UserRole[];
    if (allowed && allowed.includes(this.authRole.getUserRole())) {
      return true;
    }
    return this.router.parseUrl('/');
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    // enforce referral restriction on every child
    if (this.authRole.getIsReferral() && !state.url.startsWith('/mi-cuenta')) {
      return this.router.parseUrl('/mi-cuenta');
    }
    return true;
  }
}
